import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=656ed0c6&scoped=true&"
import script from "./Titles.vue?vue&type=script&lang=js&"
export * from "./Titles.vue?vue&type=script&lang=js&"
import style0 from "./Titles.vue?vue&type=style&index=0&id=656ed0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ed0c6",
  null
  
)

export default component.exports